import { defineComponent, reactive, watch } from "@vue/composition-api";
import './index.scss'
import _ from 'lodash'
import BarScore from "@/pages/Survey/components/BarScore";
import StarScore from "@/pages/Survey/components/StarScore";
import FaceScore from "@/pages/Survey/components/FaceScore";
const ScaleContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => { }
    }
  },
  setup(props, context) {
    const { emit } = context;
    const state = reactive({
      editItem: _.cloneDeep(props.item), //编辑数据源
      errorText: ''
    })

    watch(() => props.item, (val) => {
      state.editItem = _.cloneDeep(val);
    }, {
      deep: true
    })

    const updateValue = (value) => {
      state.editItem.value = value;
      state.editItem.isShowTitleError = false;
      emit('answer', state.editItem)
    }

    return () => {
      return (<div class='nps-topic-content'>
        {
          !props.item.topicSetting.scoreStyle && <BarScore minScoreDesc={props.item.topicSetting.minScoreDesc}
            maxScoreDesc={props.item.topicSetting.maxScoreDesc}
            maxScore={props.item.topicSetting.maxScore}
            onupdateValue={value => updateValue(value)}
            value={state.editItem.value}
            topicSetting={props.item.topicSetting}
          ></BarScore>
        }
        {
          props.item.topicSetting.scoreStyle === 1 && <StarScore minScoreDesc={props.item.topicSetting.minScoreDesc}
            maxScoreDesc={props.item.topicSetting.maxScoreDesc}
            maxScore={props.item.topicSetting.maxScore}
            onupdateValue={value => updateValue(value)}
            value={Number(state.editItem.value) || state.editItem.value}
            topicSetting={props.item.topicSetting}
          ></StarScore>
        }
        {
          props.item.topicSetting.scoreStyle === 2 && <FaceScore minScoreDesc={props.item.topicSetting.minScoreDesc}
            maxScoreDesc={props.item.topicSetting.maxScoreDesc}
            maxScore={props.item.topicSetting.maxScore}
            onupdateValue={value => updateValue(value)}
            value={Number(state.editItem.value) || state.editItem.value}
            topicSetting={props.item.topicSetting}
          ></FaceScore>
        }
      </div >)
    }
  }
})

export default ScaleContent
